import { render, staticRenderFns } from "./roboticDog.vue?vue&type=template&id=e058d548&scoped=true&"
import script from "./roboticDog.vue?vue&type=script&lang=js&"
export * from "./roboticDog.vue?vue&type=script&lang=js&"
import style0 from "./roboticDog.vue?vue&type=style&index=0&id=e058d548&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e058d548",
  null
  
)

export default component.exports